export default "__VITE_ASSET__DSlg7PWt__"